import React from "react";
import { Box, CustomPagination, DataTableBodyCell } from "@maysoft/common-component-react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import CircularProgress from "@mui/material/CircularProgress";

import Strings from "constants/strings";
import Constants from "constants/index";
import { DataNotFound } from "components";
import { IRecordDepartmentStatistics } from "commons/interfaces";



const DataTableByDepartment = ({
    data,
    pageSize,
    pageNumber,
    totalCount,
    loadingData,
    onChangePageSize,
    onChangePageNumber,
}: {
    data: IRecordDepartmentStatistics[];
    pageSize: number;
    pageNumber: number;
    totalCount: number;
    loadingData?: boolean;
    onChangePageSize: (value: any) => void;
    onChangePageNumber: (value: any) => void;
}) => {

    return (
        <>
            {loadingData &&
                <Box
                    sx={{
                        height: "40vh",
                        display: "flex",
                        borderRadius: 2,
                        alignItems: "center",
                        flexDirection: "column",
                        justifyContent: "center",
                        backgroundColor: "#f3f3f3",
                    }}
                >
                    <CircularProgress />
                </Box>
            }
            {!loadingData && (totalCount !== 0) &&
                <TableContainer sx={{ boxShadow: "none" }}>
                    <Table>
                        <Box component="thead">
                            <TableRow>
                                <CustomTableCell
                                    rowSpan={2}
                                    width={"40px"}
                                    children={"STT"}
                                />
                                <CustomTableCell
                                    rowSpan={2}
                                    width={"150px"}
                                    children={Strings.REPORT.DEPARTMENT}
                                />
                                <CustomTableCell
                                    rowSpan={2}
                                    width={"50px"}
                                    children={Strings.DATE_RANGE_PICKER.DAY}
                                />
                                <CustomTableCell
                                    rowSpan={2}
                                    width={"50px"}
                                    children={Strings.DATE_RANGE_PICKER.WEEK}
                                />
                                <CustomTableCell
                                    rowSpan={2}
                                    width={"50px"}
                                    children={Strings.DATE_RANGE_PICKER.MONTH}
                                />
                                <CustomTableCell
                                    rowSpan={2}
                                    width={"50px"}
                                    children={Strings.DATE_RANGE_PICKER.YEAR}
                                />
                                <CustomTableCell
                                    colSpan={4}
                                    textAlign={"center"}
                                    children={"Do khoa bạn báo cáo"}
                                />
                                <CustomTableCell
                                    rowSpan={2}
                                    width={"100px"}
                                    children={Strings.CHART.PROCESSED}
                                />
                            </TableRow>
                            <TableRow>
                                <CustomTableCell
                                    width={"50px"}
                                    children={Strings.DATE_RANGE_PICKER.DAY}
                                />
                                <CustomTableCell
                                    width={"50px"}
                                    children={Strings.DATE_RANGE_PICKER.WEEK}
                                />
                                <CustomTableCell
                                    width={"50px"}
                                    children={Strings.DATE_RANGE_PICKER.MONTH}
                                />
                                <CustomTableCell
                                    width={"50px"}
                                    children={Strings.DATE_RANGE_PICKER.YEAR}
                                />
                            </TableRow>
                        </Box>
                        <TableBody>
                            {[...data || []].map((item, index) => (
                                <TableRow>
                                    <DataTableBodyCell>
                                        {(index + 1) + (pageNumber - 1) * pageSize}
                                    </DataTableBodyCell>
                                    <DataTableBodyCell>
                                        {item.groupName}
                                    </DataTableBodyCell>

                                    <DataTableBodyCell>
                                        {item.today}
                                    </DataTableBodyCell>
                                    <DataTableBodyCell>
                                        {item.thisWeek}
                                    </DataTableBodyCell>
                                    <DataTableBodyCell>
                                        {item.thisMonth}
                                    </DataTableBodyCell>
                                    <DataTableBodyCell>
                                        {item.thisYear}
                                    </DataTableBodyCell>

                                    <DataTableBodyCell>
                                        {item.curDepartmentToday}
                                    </DataTableBodyCell>
                                    <DataTableBodyCell>
                                        {item.curDepartmentThisWeek}
                                    </DataTableBodyCell>
                                    <DataTableBodyCell>
                                        {item.curDepartmentThisMonth}
                                    </DataTableBodyCell>
                                    <DataTableBodyCell>
                                        {item.curDepartmentThisYear}
                                    </DataTableBodyCell>

                                    <DataTableBodyCell>
                                        {""}
                                    </DataTableBodyCell>
                                </TableRow>
                            ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            }
            {/* no data */}
            {!loadingData && (totalCount === 0) &&
                <Box textAlign="center">
                    <DataNotFound />
                </Box>
            }
            {!loadingData &&
                <Box py={2} px={{ xs: 0, sm: 2 }}>
                    <CustomPagination
                        isList
                        page={pageNumber}
                        total={totalCount}
                        pageSize={pageSize}
                        onChangePage={onChangePageNumber}
                        onChangePageSize={onChangePageSize}
                        rowsPerPageOptions={Constants.ROW_PER_PAGE_OPTIONS}
                    />
                </Box>
            }
        </>
    );
};


export default DataTableByDepartment;

const CustomTableCell = ({
    width,
    rowSpan,
    colSpan,
    children,
    textAlign,
}: {
    width?: any;
    colSpan?: number;
    rowSpan?: number;
    children?: React.ReactNode;
    textAlign?: "center" | "left" | "right";
}) => (
    <TableCell
        colSpan={colSpan}
        rowSpan={rowSpan}
        style={{
            width: width,
            backgroundColor: "#e5e7eb",
            border: "0.0625rem solid #f0f2f5",
        }}
    > {
            children &&
            <Box
                opacity={0.7}
                color={"secondary"}
                textAlign={textAlign}
                sx={(theme) => ({
                    fontWeight: 700,
                    fontSize: `${10.4 / 16}rem`,
                    textTransform: "uppercase",
                })}
            >
                {children}
            </Box>
        }
    </TableCell>
);